// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_button_container__BPtgM{
    display: flex;
    justify-content: space-between;
    margin: 2rem 0 0.7rem 0;
    gap: 1.5rem;
    height: 36px;
}

  @media (max-width: 770px) {
    .styles_button_container__BPtgM {
        flex-direction: column-reverse;
        height: auto;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/BotaoRelatorio/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;EAEE;IACE;QACI,8BAA8B;QAC9B,YAAY;IAChB;EACF","sourcesContent":[".button_container{\n    display: flex;\n    justify-content: space-between;\n    margin: 2rem 0 0.7rem 0;\n    gap: 1.5rem;\n    height: 36px;\n}\n\n  @media (max-width: 770px) {\n    .button_container {\n        flex-direction: column-reverse;\n        height: auto;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button_container": `styles_button_container__BPtgM`
};
export default ___CSS_LOADER_EXPORT___;
